import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_cannot_take_short_ergonomic_breaks_during_work'

export const dataPointDefinition = {
  retracedId: 'workers_cannot_take_short_ergonomic_breaks_during_work',
  name: 'Workers cannot take short ergonomic breaks during the work day',
  description:
    'Ergonomic breaks are defined as rest breaks from sedentary work (e.g. sitting in one place/position) or repetitive work (leaning down over and over). Breaks might include work pauses (from repetitive work), standing, walking, stretching, and/or changing body position.   ',
  meta: {
    slcpMeta: {
      key: 'hs-wor-47x',
      number: 'HS-WOR-23-3',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-44',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-33,Yes',
      machineShowHide: '[2],hs-33,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-47x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31880,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
